import { KEY_LOCAL_STORAGE_TOKEN } from '../../../auth/Auth.constants'

class Session {
  static set(key, value) {
    const jsonObject = key === KEY_LOCAL_STORAGE_TOKEN ? value : JSON.stringify(value)
    window.localStorage.setItem(key, jsonObject)
  }

  static get(key) {
    const jsonObject = window.localStorage.getItem(key)
    if (key === KEY_LOCAL_STORAGE_TOKEN) return jsonObject
    return JSON.parse(jsonObject)
  }

  static remove() {
    window.localStorage.clear()
  }
}

export default Session
